<div class="video_body">
    <div class="video_body_wrapper">
        <!-- <p class="studio_heading"><b  class="cursor">Back < </b>Edit SRT File: </p> -->
        <div>
            <p class="studio_heading">File Name</p>
        </div>
        <div class="d-flex flex-row gap-2 align-items-center space-between w-25">
            <button type="button" class="btn btn-generate-srt w-100" (click)="addMetadata()">
                Add Metadata
            </button>

            <button (click)="back()" class="update_card_btn_card">
                <img src="/assets/images/dashboard-icons/arrow-back.svg" alt="" />
                Back to files
            </button>
        </div>
    </div>

    <div class="row content-body">
        <div class="upper-box">
            <div class="column-video-wrapper">
                <div class="column-video w-75">
                    <div class="col">
                        <div class="group_search">
                            <select name="language" class="form-control type_form_control" [value]="language"
                                (change)="changeLanguage($event)">
                                <option [disabled]="true">Languages</option>
                                <option value="en">English</option>
                                <option value="hi">Hindi</option>
                                <option value="zh-CN">Mandarin</option>
                                <option value="ko">Korean</option>
                                <option value="es">Spanish</option>
                                <option value="fr">French</option>
                                <option value="ja">Japanese</option>
                                <option value="pt">Portuguese</option>
                                <option value="it">Italian</option>
                                <option value="af">Afrikaans</option>
                            </select>
                        </div>
                    </div>
                    <!-- <div class="col">
            <div class="group_search">
                <select name="speaker" class="form-control type_form_control" (change)="changeSpeakerSymbols($event)">
                    <option value="[]">
                        [ {{ title.speaker }} ] ( {{ title.nonSpeach }} )
                    </option>
                    <option value="()">
                        ({{ title.speaker }}) [ {{ title.nonSpeach }} ]
                    </option>
                </select>
            </div>
        </div> -->
                    <div class="col">
                        <div class="group_search">
                            <select name="case" class="form-control type_form_control" [value]="case"
                                (change)="changeCase($event)">
                                <option value="0">{{ title.normal }}</option>
                                <option value="1">{{ title.upperCase }}</option>
                                <option value="2">{{ title.lowerCase }}</option>
                            </select>
                        </div>
                    </div>
                    <!-- <div class="col">
        <div class="group_search">
          <select name="punctuation" class="form-control type_form_control" [value]="Punctuation">
            <option [disabled]="true" value=0>{{title.selectaddPunctuation}}</option>
            <option value=1>{{title.addPunctuation}} </option>
            <option value=2>{{title.removePunctuation}}</option>
          </select>
        </div>
      </div> -->

                    <!-- <div class="col">
                        <div class="group_search">
                            <select name="tense" class="form-control type_form_control" [value]="Tense"
                                (change)="changeTense($event)">
                                <option [disabled]="true" value="0">
                                    {{ title.Selecttense }}
                                </option>
                                <option value="1">
                                    {{ title.presentTense }}
                                </option>
                                <option value="2">
                                    {{ title.participleTense }}
                                </option>
                            </select>
                        </div>
                    </div> -->

                    <div *ngIf="characters?.length > 1">
                        <div>
                            <div class="form-check form-switch toggle-switch">
                                <label class="form-check-label toggle-label" for="myToggleSwitch">Assign
                                    Character</label>
                                <input class="form-check-input" type="checkbox" role="switch" id="myToggleSwitch"
                                    (change)="toggleCharacterSelect()" />
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="group_search">
                            <button type="button" class="btn btn-generate-srt" (click)="onSave()"
                                *ngIf="showCharacterSelect">
                                Save
                            </button>
                        </div>
                    </div>
                    <!-- <div class="col">
        <div class="group_search">
          <select name="tense" class="form-control type_form_control" [value]="Tense">
            <option [disabled]="true" value=0>{{title.Selecttense}}</option>
            <option value=1>{{title.presentTense}}</option>
            <option value=2>{{title.participleTense}} </option>
          </select>
        </div>
      </div> -->
                    <!-- <div class="col">
            <div class="group_search">
                <select
                    name="tense"
                    class="form-control type_form_control"
                    [value]="Tense"
                    (change)="changeTense($event)"
                >
                    <option [disabled]="true" value="0">
                        {{ title.Selecttense }}
                    </option>
                    <option value="1">{{ title.presentTense }}</option>
                    <option value="2">{{ title.participleTense }}</option>
                </select>
            </div>
        </div> -->
                </div>
                <div class="column-video">
                    <div class="col">
                        <div class="group_search">
                            <button type="button" class="btn btn-generate-srt w-100" (click)="srtUpdate()">
                                Update SRT
                            </button>
                        </div>
                    </div>
                    <div>
                        <div class="col">
                            <div class="group_search">
                                <div class="dropdown">
                                    <button class="btn btn-generate-srt dropdown-toggle" type="button"
                                        data-bs-toggle="dropdown">
                                        Generate Subtitle
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <button class="dropdown-item" (click)="srtGenerate()">
                                                Generate SRT
                                            </button>
                                        </li>
                                        <li>
                                            <button class="dropdown-item" (click)="stlGenerate()">
                                                Generate STL
                                            </button>
                                        </li>
                                        <li>
                                            <button class="dropdown-item" (click)="vttGenerate()">
                                                Generate VTT
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="col">
                            <div class="group_search">
                                <button type="button" class="btn btn-generate-srt" (click)="generateDialogSheetCSV()">
                                    Generate Dialogue Sheet
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="video_body_box mx-auto px-4 sm:px-6 lg:px-8 max-w-[1440px]">
                <div class="video_list">
                    <div class="video_list_inner">
                        <div class="video_card">
                            <div class="ratio ratio-16x9">
                                <vg-player style="
                                        background: transparent;
                                        border-radius: 8px;
                                    ">
                                    <video [vgMedia]="$any(media)" #media id="singleVideo" preload="auto" controls
                                        style="width: 100%">
                                        <source [src]="videoPresignedUrl" type="video/mp4" />
                                    </video>
                                    <vg-overlay-play></vg-overlay-play>
                                    <vg-buffering></vg-buffering>
                                </vg-player>
                            </div>
                        </div>

                        <div class="video_card p_16 d-none">
                            <div class="video_btn_tab">
                                <div class="row mt-4 align-items-center" *ngIf="speakers?.length > 0">
                                    <!-- Speaker Dropdown -->
                                    <div class="d-flex flex-column flex-lg-row gap-2">
                                        <div class="d-flex align-items-center gap-2">
                                            <div class="group_search">
                                                <label for="speakerSelect" class="form-label">Select Speaker</label>
                                                <select id="speakerSelect" class="form-control" [(ngModel)]="
                                                        selectedSpeaker
                                                    " (change)="onSpeakerChange()">
                                                    <option *ngFor="
                                                            let speaker of speakers
                                                        " [value]="speaker">
                                                        {{ speaker }}
                                                    </option>
                                                </select>
                                            </div>
                                            <!-- "+" button to the right of speaker selection box -->
                                            <div class="d-flex align-items-center" data-bs-toggle="modal"
                                                data-bs-target="#add_speaker" tabindex="0">
                                                <img src="/assets/images/plus.png" alt="Add Speaker" style="
                                                        height: 24px;
                                                        width: 24px;
                                                        margin-top: 28px;
                                                    " />
                                            </div>
                                        </div>

                                        <!-- Character Dropdown -->
                                        <div class="d-flex align-items-center gap-2">
                                            <div class="group_search">
                                                <label for="characterSelect" class="form-label">Select Character</label>
                                                <select id="characterSelect" class="form-control" [(ngModel)]="
                                                        selectedCharacter
                                                    ">
                                                    <!-- Default placeholder option -->
                                                    <option value="" disabled selected>
                                                        Select a Character
                                                    </option>
                                                    <option *ngFor="
                                                            let character of characters
                                                        " [value]="character">
                                                        {{ character }}
                                                    </option>
                                                </select>
                                            </div>
                                            <!-- "+" button to the right of character selection box -->
                                            <div class="d-flex align-items-center" data-bs-toggle="modal"
                                                data-bs-target="#add_metadata" tabindex="0">
                                                <img src="/assets/images/plus.png" alt="Add Metadata" style="
                                                        height: 24px;
                                                        width: 24px;
                                                        margin-top: 28px;
                                                    " />
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Apply, Save, Reset Buttons -->
                                    <div class="d-flex flex-column flex-lg-row gap-1 mt-2">
                                        <button type="button" class="btn btn-primary mt-3 mt-md-0" (click)="
                                                replaceSpeakerWithCharacter()
                                            ">
                                            Apply
                                        </button>
                                        <button style="margin-left: 4px" class="btn btn-primary mt-3 mt-md-0"
                                            (click)="onSave()">
                                            Save
                                        </button>
                                        <button style="margin-left: 4px" class="btn btn-primary mt-3 mt-md-0"
                                            (click)="resetSrt()">
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="video_list_inner">
                        <div class="video_card_d">
                            <!-- <div class="video_card_d_header" style="display: flex; align-items: center; gap: 20px;"> -->
                            <!-- Case Dropdown -->
                            <!-- <div class="col">
                <div class="group_search">
                  <select name="case" class="form-control type_form_control" [value]="case" (change)="changeCase($event)"
                    style="border: 1px solid #ccc; border-radius: 4px; width: 170px; padding: 5px;">
                    <option value="0">{{ title.normal }}</option>
                    <option value="1">{{ title.upperCase }}</option>
                    <option value="2">{{ title.lowerCase }}</option>
                  </select>
                </div>
              </div> -->

                            <!-- Speaker Dropdown -->
                            <!-- <div class="col">
                <div class="group_search">
                  <select name="speaker" class="form-control type_form_control" (change)="changeSpeakerSymbols($event)"
                    [value]="speaker" style="border: 1px solid #ccc; border-radius: 4px; width: 170px; padding: 5px;">
                    <option value="[]">[ {{ title.speaker }} ] ( {{ title.nonSpeach }} )</option>
                    <option value="()">({{ title.speaker }}) [ {{ title.nonSpeach }} ]</option>
                  </select>
                </div>
              </div> -->

                            <!-- Generate SRT Button -->
                            <!-- </div> -->

                            <div class="video_card_d_body">
                                <div *ngFor="
                                        let section of transcriptionSections;
                                        let i = index
                                    " class="time_media">
                                    <div class="time_media_left">
                                        <span>{{
                                            formatTime(section.start)
                                            }}</span>
                                        <span>-</span>
                                        <span>{{
                                            formatTime(section.end)
                                            }}</span>

                                        <div class="mt-2" style="
                                                display: flex;
                                                flex-direction: column;
                                            ">
                                            <button class="" style="
                                                    text-align: center;
                                                    padding: 0.5rem;
                                                    border: 1px solid
                                                        transparent;
                                                " (click)="
                                                    removeTranscriptionSection(
                                                        i
                                                    )
                                                ">
                                                Remove section
                                            </button>
                                            <div class="speaker-select-wrapper" *ngIf="showCharacterSelect">
                                                <button class="paint-color-icon" [style.backgroundColor]="
                                                        'transparent'
                                                    " (click)="
                                                        togglePicker(i, $event)
                                                    ">
                                                    <img src="/assets/images/dashboard-icons/colors.svg" alt=""
                                                        width="100%" height="100%" *ngIf="
                                                            !hidePaintColorIcon(
                                                                section.speaker
                                                            )
                                                        " />
                                                </button>

                                                <span class="color-circle" [style.backgroundColor]="
                                                        characterColors[
                                                            section.speaker
                                                        ] || '#ffffff'
                                                    " (click)="
                                                        togglePicker(i, $event)
                                                    ">
                                                </span>

                                                <div class="color-palette" *ngIf="isPickerOpen === i" (document:click)="
                                                        isPickerOpen = null
                                                    ">
                                                    <div *ngFor="
                                                            let color of colorOptions
                                                        " class="color-option" [style.backgroundColor]="
                                                            color
                                                        " (click)="
                                                            selectColor(
                                                                section.speaker,
                                                                color
                                                            )
                                                        "></div>
                                                </div>

                                                <select [(ngModel)]="
                                                        section.speaker
                                                    " (change)="
                                                        updateCharacter(
                                                            i,
                                                            $event
                                                        )
                                                    " class="form-select speaker_control" [ngStyle]="{
                                                        'background-color':
                                                            getBackgroundColor(
                                                                section.speaker
                                                            )
                                                    }">
                                                    <option *ngFor="
                                                            let character of characters
                                                        " [value]="character">
                                                        <!-- {{ sp }} -->
                                                        {{ character }}
                                                    </option>
                                                </select>
                                            </div>
                                            <!-- Optional: color picker to override -->
                                        </div>
                                    </div>
                                    <div class="time_media_body">
                                        <div class="time_media_body_inner">
                                            <div *ngIf="section.text">
                                                <div class="editor-wrapper">
                                                    <div class="scroll-container">
                                                        <!-- Highlight layer -->
                                                        <div class="highlight-layer" [innerHTML]="
                                                            section.processedText
                                                        "></div>

                                                        <!-- Textarea on top -->
                                                        <!-- <textarea class="editor-textarea" [(ngModel)]="
                                                            section.text
                                                        " (input)="
                                                            onTextChange(i)
                                                        ">
                                                    </textarea> -->
                                                        <textarea spellcheck="false"
                                                            class="editor-textarea form-control video_text_control" [(ngModel)]="
                                                            section.text
                                                        " (input)="
                                                            onTextChange(
                                                                i,
                                                                section.text
                                                            )
                                                        " (scroll)="textareaScroll($event)"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="section.sound?.present">
                                                <textarea class="form-control video_text_control">{{
                                                        section.sound.present
                                                    }}</textarea>
                                            </div>

                                            <div class="hover_link">
                                                <div class="hover_link_group">
                                                    <div class="d-flex flex-row gap-0 mb-0 align-items-center">
                                                        <button (click)="
                                                                seekVideoTo(
                                                                    section.start
                                                                )
                                                            " class="hover_btn_link bg-transparent"
                                                            style="height: 13px">
                                                            <img src="/assets/images/play-once.png" alt="Play Once" />
                                                        </button>
                                                        <button (click)="
                                                                seekVideoTo(
                                                                    section.start
                                                                )
                                                            " class="hover_btn_link" style="height: 13px">
                                                            <img src="/assets/images/play.svg" alt="Play" />
                                                        </button>
                                                        <button (click)="
                                                                initiateSpellCheck()
                                                            " class="hover_btn_link" style="height: 13px">
                                                            Spell
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="upper-box mt-4 d-none">
            <div *ngIf="speakerVideos.length > 0" class="video-list mt-4">
                <h4>Videos for {{ selectedSpeaker }}</h4>
                <div class="video-container">
                    <div *ngFor="let video of speakerVideos" class="video-item">
                        <p>{{ video.name }}</p>
                        <video width="100%" height="200" controls>
                            <source [src]="video.url" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </div>

            <div *ngIf="speakerVideos.length === 0 && selectedSpeaker" class="mt-4">
                <p>No videos found for {{ selectedSpeaker }}.</p>
            </div>
        </div>

        <div class="modal fade" id="find_modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
            aria-labelledby="find_modalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered find_modal_diologe">
                <div class="modal-content find_modal_content">
                    <div class="modal-header find_modal_header">
                        <img src="/assets/images/cancel.png" alt="close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div class="modal-body find_modal_body">
                        <div class="find_from_box">
                            <div class="find_from_left">
                                <div class="add_form_group">
                                    <p class="add_label">Find</p>
                                    <input type="text" class="form-control add_form_control" placeholder="" />
                                </div>
                            </div>
                            <div class="find_from_right">
                                <div class="add_form_group">
                                    <p class="add_label">Find Form</p>
                                    <select class="form-select add_form_control" aria-label="Default select example">
                                        <option selected>
                                            Original Subtitle
                                        </option>
                                        <option value="1">
                                            Original Subtitle
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="find_modal_check mb-3">
                            <div class="form-check ai_check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                <label class="form-check-label" for="flexCheckDefault">
                                    Case Sensitive
                                </label>
                            </div>
                            <div class="form-check ai_check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                <label class="form-check-label" for="flexCheckDefault">
                                    Match Whole Word
                                </label>
                            </div>
                        </div>
                        <div class="add_form_group">
                            <p class="add_label">Replace With</p>
                            <input type="text" class="form-control add_form_control" placeholder="" />
                        </div>
                        <div class="text_main_box">
                            <div class="text_main_left">
                                <p>Start Time</p>
                                <p>
                                    Original text <span>(Click to locate)</span>
                                </p>
                            </div>
                            <div class="text_main_right">
                                <p>Results</p>
                            </div>
                        </div>
                        <div class="no_result">
                            No results found for this filter
                        </div>
                    </div>
                    <div class="modal-footer find_modal_footer">
                        <p>Total 0 results</p>
                        <a [routerLink]="['./']" class="btn create_link">Replace</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="activatemodal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
            aria-labelledby="activatemodalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header activate_header">
                        <h1 class="activate_heading" id="activatemodalLabel">
                            Notice
                        </h1>
                        <img src="/assets/images/cancel.png" alt="close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div class="modal-body">
                        <p class="upgrade_text">
                            Upgrade to
                            <span><img src="/assets/images/pro-icon.png" alt="" /></span>
                            for access
                        </p>
                        <a type="button" class="btn create_link width-100">Upgrade</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="add_metadata" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
            aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header card_add_header">
                        <p class="new_caed_modal_heading">
                            <span>{{ videos.addMetadata }}</span>{{ videos.metaContent }}
                        </p>
                        <img src="/assets/images/cancel.png" class="cursor_pointer" (click)="resets()"
                            data-bs-dismiss="modal" aria-label="Close" alt="" />
                    </div>
                    <div class="modal-body card_add_body">
                        <div class="card_add_body_inner">
                            <div>
                                <label class="add_label">{{
                                    videos.inputNumber
                                    }}</label>
                                <input type="number" class="form-control add_form_control" [(ngModel)]="quantity"
                                    (input)="createInputs($event)" />
                            </div>
                            <br />

                            <form [formGroup]="myForm">
                                <div formArrayName="inputs">
                                    <div *ngFor="
                                            let group of inputs.controls;
                                            let i = index
                                        " [formGroupName]="i">
                                        <div class="row">
                                            <!-- Name Input -->
                                            <div class="col-md-6">
                                                <div class="add_form_group">
                                                    <p class="add_label">
                                                        {{ videos.name }}
                                                    </p>
                                                    <input type="text" class="form-control add_form_control"
                                                        formControlName="name" [placeholder]="
                                                            videos.nameP
                                                        " />
                                                </div>
                                            </div>

                                            <!-- Image Upload Input -->
                                            <div class="col-md-6">
                                                <div class="add_form_group">
                                                    <p class="add_label">
                                                        {{ videos.uploadImage }}
                                                    </p>
                                                    <input type="file" accept="image/*" (change)="
                                                            handleMetadataImage(
                                                                $event,
                                                                i
                                                            )
                                                        " class="form-control add_form_control"
                                                        formControlName="image" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="modal-footer card_add_footer">
                        <button type="button" class="btn make_payment_cancel_btn" #modalCloseButton1
                            data-bs-dismiss="modal">
                            {{ videos.cancel }}
                        </button>
                        <div *ngIf="isClicked">
                            <button class="btn make_payment_btn ms-3" type="button" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                {{ videos.loading }}
                            </button>
                        </div>
                        <button *ngIf="!isClicked" class="btn make_payment_btn" (click)="onSubmit()">
                            {{ videos.submit }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="add_speaker" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
            aria-labelledby="addSpeakerModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header card_add_header">
                        <h5 class="modal-title new_caed_modal_heading" id="addSpeakerModalLabel">
                            Add Speaker
                        </h5>
                        <img src="/assets/images/cancel.png" class="cursor_pointer" data-bs-dismiss="modal"
                            aria-label="Close" alt="" />
                    </div>
                    <div class="modal-body card_add_body">
                        <div class="card_add_body_inner">
                            <div>
                                <label class="add_label">Speaker Name</label>
                                <input type="text" class="form-control add_form_control" [(ngModel)]="newSpeakerName"
                                    placeholder="Enter new speaker name" required />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer card_add_footer">
                        <button type="button" class="btn make_payment_cancel_btn" data-bs-dismiss="modal">
                            Cancel
                        </button>
                        <button type="button" class="btn make_payment_btn" (click)="addNewSpeaker()">
                            Add Speaker
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>